import $ from "jquery";

$(function () {
  // Video Player Functionality
  const play_buttons = document.querySelectorAll(".play-btn");

  play_buttons.forEach((button) => {
    button.addEventListener("click", function () {
      const videoElement = this.previousElementSibling;
      const poster = this.nextElementSibling;

      this.style.display = "none";
      poster.style.display = "none";

      // Stop all other videos before playing the new one
      document.querySelectorAll(".video").forEach((otherVideo) => {
        if (otherVideo !== videoElement) {
          const otherPlayButton = otherVideo.nextElementSibling;
          const otherPoster = otherPlayButton.nextElementSibling;
          if (otherVideo.tagName.toLowerCase() === "iframe") {
            // Reset the iframe source without autoplay
            const iframeSrc = otherVideo.src.split("&autoplay=1")[0]; // Remove autoplay if present
            otherVideo.src = iframeSrc;
          } else if (otherVideo.tagName.toLowerCase() === "video") {
            // Pause the HTML5 video
            otherVideo.pause();
            otherVideo.currentTime = 0; // Optional: reset video to the beginning
          }
          // Unhide the play button and poster for the stopped video
          otherPlayButton.style.display = "block";
          otherPoster.style.display = "block";
        }
      });

      // Check if the videoElement is an iframe or a video tag
      if (videoElement.tagName.toLowerCase() === "iframe") {
        // Play the iframe video (YouTube)
        const videoSrc = videoElement.src;
        videoElement.src =
          videoSrc + (videoSrc.includes("&autoplay=1") ? "" : "&autoplay=1");
      } else if (videoElement.tagName.toLowerCase() === "video") {
        // Play the HTML5 video
        videoElement.play();
      }
    });
  });

  // Load More Blog Posts functionality
  $("#load-more-button").on("click", function () {
    let button = $(this);
    let no_posts = $(".no-posts");
    let page = button.data("page");
    let ajaxurl = button.data("url");

    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "load_more_posts",
        page: page,
      },
      success: function (response) {
        let data = JSON.parse(response);
        if (data.posts) {
          $("#load-more").append(data.posts);
          button.data("page", page + 1);
          if (data.no_more_posts) {
            button.hide();
            no_posts.removeClass("d-none");
          }
        } else {
          button.hide();
        }
      },
    });
  });
  // TEAM MEMBER MODALS (Currently unimplemented)
  // var leaderImages = document.querySelectorAll(".team-leader");
  // var modalTitle = document.getElementById("leaderModalLabel");
  // var modalImage = document.getElementById("leaderImage");
  // var modalPosition = document.getElementById("leaderPosition");
  // var modalBio = document.getElementById("leaderBio");
  // leaderImages.forEach(function (image) {
  //   image.addEventListener("click", function () {
  //     var name = this.getAttribute("data-name");
  //     var position = this.getAttribute("data-position");
  //     var bio = this.getAttribute("data-bio");
  //     var src = this.getAttribute("src");
  //     modalTitle.textContent = name;
  //     modalImage.setAttribute("src", src);
  //     modalImage.setAttribute("alt", name);
  //     modalPosition.textContent = position;
  //     modalBio.textContent = bio;
  //   });
  // });
});
